var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { imageGrandmaWithChild } from 'hx-assets';
import { NavButton, NavButtons } from 'hx-navigator';
import { SideImageLayout, StandardLayout } from 'hx-ui';
import { useSyncFormWithStore } from 'hx-wizard';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { getStoredState } from 'redux-persist';
import sessionStorage from 'redux-persist/es/storage/session';
import { Footer } from '@/components/footer.component';
import { updateSpeakToAnExpertForm } from '@/store';
import SpeakToAnExpertForm from '@/components/speak-to-an-expert-form.component';
export function SpeakToAnExpertFormPage() {
    var _this = this;
    var hydrateFormValues = function (_a) {
        var userDetails = _a.userDetails;
        userDetails['first-name'] &&
            form.setValue('first-name', userDetails['first-name']);
        userDetails['last-name'] &&
            form.setValue('last-name', userDetails['last-name']);
        userDetails.email && form.setValue('email', userDetails.email);
        userDetails['contact-number'] &&
            form.setValue('contact-number', userDetails['contact-number']);
    };
    useEffect(function () {
        getStoredState({
            key: 'widget',
            storage: sessionStorage,
        }).then(function (state) { return hydrateFormValues(state); });
    }, []);
    var navigate = useNavigate();
    var form = useForm({
        mode: 'onBlur',
        defaultValues: {
            'country-code': '+1',
            'preferred-contact-time': 'am',
            'preferred-contact-method': {
                email: false,
                'text-message': false,
                'voice-call': false,
                'video-call': false,
            },
        },
    });
    useSyncFormWithStore(form, ['speakToAnExpertForm'], updateSpeakToAnExpertForm, [
        'preferred-contact-method.email',
        'preferred-contact-method.text-message',
        'preferred-contact-method.voice-call',
        'preferred-contact-method.video-call',
    ]);
    var onSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            navigate('/selection');
            return [2 /*return*/];
        });
    }); };
    return (_jsx(SideImageLayout, { className: 'overflow-y-auto', imageLeft: imageGrandmaWithChild, content: _jsx(FormProvider, __assign({}, form, { children: _jsx("form", __assign({ className: "grid h-full gap-4", onSubmit: form.handleSubmit(onSubmit) }, { children: _jsx(StandardLayout, { contentHeader: _jsx("div", __assign({ className: "grid px-4 py-8 place-items-center" }, { children: _jsx(Typography, __assign({ variant: "h2" }, { children: _jsx("b", { children: "Thank you for completing the hearing screener" }) })) })), content: _jsxs("div", __assign({ className: "grid gap-4 px-4 place-items-center" }, { children: [_jsx(Typography, __assign({ variant: "body1", className: "text-center" }, { children: "In order to view your results, please complete your details below:" })), _jsx(SpeakToAnExpertForm, { form: form })] })), nav: _jsx(NavButtons, { children: _jsx(NavButton, { type: "submit", label: "Next" }) }), contentFooter: _jsx(Footer, {}) }) })) })) }));
}
